import * as React from 'react';
import { useEffect, useState } from 'react';
import axiosApiInstance from '../../../api/axiosClient';
import { Button, notification, Tooltip } from 'antd';
import { ModalForm } from '@ant-design/pro-components';
import { ExportOutlined } from '@ant-design/icons';
import { queryClientAtom } from 'jotai-tanstack-query';
import { useAtomValue } from 'jotai';
import { ProFormCheckbox, ProFormDatePicker, ProFormGroup } from '@ant-design/pro-form';

type Props = {
    upc_ean: string;
    id: string;
    release: API.MusicDistribution.MusicRelease;
};

const ModifyRelease = (props: Props) => {
    const queryClient = useAtomValue(queryClientAtom);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState<Array<string>>([]);

    useEffect(() => {
        return setSelected([]);
    }, []);

    return (
        <ModalForm
            width={600}
            title={'Modify Release'}
            trigger={
                <Tooltip title={'Modify Release...'}>
                    <Button
                        type={'link'}
                        icon={<ExportOutlined />}
                        // icon={<DeleteOutlined/>}
                    />
                </Tooltip>
            }
            // submitter={{submitButtonProps: {danger: true}}}
            autoFocusFirstInput
            modalProps={{
                destroyOnClose: true,
                closable: !loading,
                maskClosable: !loading,
                okText: 'Modify',
                cancelText: 'Cancel',
                onCancel() {
                    setSelected([]);
                }
            }}
            onFinish={async (params) => {
                // message.info(values.upload_to)
                console.log(params);
                setLoading(true);
                setSelected([]);
                return (
                    axiosApiInstance
                        // .put(`/api/products/releases/${props.id}/upload/${values.upload_to}`)
                        .put(`/api/products/releases/${props.id}/modify`, undefined, {
                            params
                        })
                        .then((res) => {
                            // console.log(res)
                            setLoading(false);
                            // queryClient.invalidateQueries({queryKey: ['creators','items']})
                            notification.success({
                                message: 'Success',
                                description: 'Release modified successfully'
                            });
                            // queryClient.invalidateQueries({queryKey: ['creators']})
                            return true;
                        })
                        .catch((reason) => {
                            setLoading(false);
                            return false;
                        })
                );
            }}
        >
            <ProFormCheckbox.Group
                name='platform'
                label='Modify Platform'
                required
                requiredMark={false}
                fieldProps={{
                    onChange(checkedValue) {
                        setSelected(checkedValue as Array<string>);
                    }
                }}
                options={[
                    {
                        label: 'YouTube',
                        value: 'youtube'
                    },
                    {
                        label: 'Believe',
                        value: 'believe'
                    },
                    {
                        label: 'Spotify',
                        value: 'spotify'
                    }
                ]}
            />
            <ProFormGroup title='Release Dates'>
                <ProFormDatePicker
                    name='custom_release_date_youtube'
                    label='YouTube Music'
                    initialValue={props.release.digital_release_date}
                    // Emit a full timestamp (matches Upload) so the backend deal-start
                    // parser accepts it; a bare YYYY-MM-DD is rejected.
                    normalize={(value) => value?.format('YYYY-MM-DD[T]00:00:00[Z]')}
                    disabled={!selected.includes('youtube')}
                />
                <ProFormDatePicker
                    name='custom_release_date_believe'
                    label='Believe'
                    initialValue={props.release.digital_release_date}
                    normalize={(value) => value?.format('YYYY-MM-DD[T]00:00:00[Z]')}
                    disabled={!selected.includes('believe')}
                />
                <ProFormDatePicker
                    name='custom_release_date_spotify'
                    label='Spotify'
                    initialValue={props.release.digital_release_date}
                    normalize={(value) => value?.format('YYYY-MM-DD[T]00:00:00[Z]')}
                    disabled={!selected.includes('spotify')}
                />
            </ProFormGroup>
        </ModalForm>
    );
};

export default ModifyRelease;
